export default __webpack_public_path__ + "static/media/ic-back.516f2488.svg";